import React from "react";

import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Regattas from "./pages/Regattas";
import { Routes, Route, Link } from "react-router-dom";

import "./App.css";
import ScrollToTop from "./ScrollUp";

export default function App() {
  return (
    <div>
      <nav className="navbar">
        <Link to="/">Home</Link>
        {/* <Link to="/Regattas">Regattas</Link> */}
        <a href="/home#about">About</a>
        <a href="/home#gallery">Gallery</a>
        <Link to="/contact">Contact</Link>
        
      </nav>

      {/* Scroll to top on route change */}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/home" element={<Home />} />
      </Routes>

      <footer>
        <p>© 2025 Reid Sojka - Sailing</p>
      </footer>
    </div>
  );
}
